export default (url: string): string => {
  return `background-image: url(${url});`;
};
